<script setup>
// Selo curto do Plano Camisa 7, logo abaixo do nome do contato (pedido do Douglas em 21/08).
//
// A ficha completa fica no Painel do Torcedor, mais abaixo e às vezes fora da área visível. O
// selo aqui resolve o "bater o olho": o agente vê o vínculo no mesmo lugar onde já olha o nome,
// antes de rolar qualquer coisa.
//
// Só o essencial: vínculo e plano. Vigência, ingressos e alertas continuam na ficha, senão isto
// vira uma segunda ficha e as duas competem.
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFichaSocio } from 'dashboard/composables/useFichaSocio';

const props = defineProps({
  conversationId: { type: [String, Number], default: null },
  cpf: { type: String, default: '' },
});

const { t } = useI18n();
const { garantir, dadosDe } = useFichaSocio();

watch(
  () => [props.conversationId, props.cpf].join('|'),
  () => garantir(props.conversationId, props.cpf),
  { immediate: true }
);

const dados = computed(() => dadosDe(props.conversationId, props.cpf));

// Sem CPF, base fora do ar ou integração desligada: nada aparece. Aqui não é lugar de explicar
// ausência, e a ficha já faz isso com a orientação certa para cada caso.
const socio = computed(() => {
  const d = dados.value;
  if (!d || d.disponivel === false) return null;
  if (d.encontrado === false) return { socio: false };
  return d.encontrado === true ? d : null;
});
</script>

<template>
  <div v-if="socio" class="flex flex-wrap items-center gap-1.5">
    <span
      class="inline-flex items-center gap-1 px-1.5 py-0.5 text-[11px] font-bold tracking-wide border rounded"
      :class="
        socio.socio
          ? 'bg-[#d4af37]/15 border-[#d4af37]/50 text-[#7a5f13] dark:text-[#e8cf7a]'
          : 'bg-black/[0.04] border-black/15 text-[#3f3f46] dark:bg-white/[0.06] dark:border-white/15 dark:text-[#d4d4d8]'
      "
    >
      <span
        class="leading-none"
        :class="socio.socio ? 'text-[#d4af37]' : 'text-[#18181b] dark:text-[#a1a1aa]'"
      >
        ★
      </span>
      {{
        socio.socio
          ? t('FANDATA_SIDEBAR.FICHA_SOCIO.E_SOCIO')
          : t('FANDATA_SIDEBAR.FICHA_SOCIO.NAO_SOCIO')
      }}
    </span>
    <span
      v-if="socio.plano"
      class="px-1.5 py-0.5 text-[11px] font-semibold tracking-wide uppercase rounded bg-[#d4af37]/10 text-[#7a5f13] dark:text-[#e8cf7a]"
    >
      {{ socio.plano }}
    </span>
  </div>
</template>
